import Constants from '../Constants';

/*

This class is intended to be used in conjunction withe the "CurrentUser" class.
The "CurrentUser" class is a place to store values specific to the current user, for example their cookie consent preferences
However, at the time of writing, the reactjs codebase is not the only front-end used on the site. So this class is intended
to be an interface into the sorage used by the old jQuery frontend. 

For example, in the new react code, if we need to set "customerType", for the current user, we also need to set the old "global_customer_type"
value and perform a mapping to and from the new values.

When all of the jquery code is retired, this class too, can be retired.
*/

class LegacyApplication {
  constructor() {
    this.keyMap = new Object();
    this.keyMap[Constants.cacheKeys.orderId] = 'eir_current_order';
    this.keyMap[Constants.cacheKeys.customerType] = 'global_customer_type';
    this.keyMap[Constants.cacheKeys.cookieConsent] = 'eir_cookie_msg';
    this.keyMap[Constants.cacheKeys.upgradeCheck] = { storageKey: 'eir_upgrade_check', cookieKey: 'eir_upgrade_check_id' };
  }

  getAttribute(name) {
    // wrap the old ways of saving customer type in local storage and cookies
    let key = this.keyMap[name];

    if (name === Constants.cacheKeys.customerType) {
      let value = localStorage.getItem(key);
      
      if (value) {
        return value.toUpperCase() === 'NEW' ? 'NEW' : 'FTC';
      }

    } else if (name === Constants.cacheKeys.cookieConsent) {
      return this.getCookie(key);

    } else if (name === Constants.cacheKeys.upgradeCheck) {
      let upgradeCheck = localStorage.getItem(key.storageKey);
      let upgradeCheckId = this.getCookie(key.cookieKey);

      if (upgradeCheck && upgradeCheckId) {
        upgradeCheck = JSON.parse(upgradeCheck);

        return {
          number: upgradeCheck.msisdn,
          id: upgradeCheckId
        };

      } else if (upgradeCheck || upgradeCheckId) {
        this.removeAttribute(name);
      }

    } else if (name === Constants.cacheKeys.orderId) {
      return this.getCookie(key);
    }

    return null;
  }

  getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }

  setCookie(cname, cvalue) {
    let d = new Date();
    d.setTime(d.getTime() + 800 * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  removeCookie(cname) {   
    document.cookie = cname + '=; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';  
  }

  setAttribute(name, value) {

    if (name === Constants.cacheKeys.customerType && value) {
      localStorage.setItem(
        this.keyMap[name],
        value.toUpperCase() === 'NEW' ? 'new' : 'existing'
      );

    } else if (name === Constants.cacheKeys.cookieConsent && value) {
      this.setCookie(this.keyMap[name], value);

    }
  }

  removeAttribute(name) {
    let key = this.keyMap[name];

    if (name === Constants.cacheKeys.upgradeCheck) {
      localStorage.removeItem(key.storageKey);
      this.removeCookie(key.cookieKey);
    }
  }
}

export let legacyApplication = new LegacyApplication();
